"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  key: 'validateOn',
  ignore: true
}];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/formiojs/components/survey/editForm/Survey.edit.validation.js
// module id = 2960
// module chunks = 0